import { PopperPlacementType } from '@material-ui/core/Popper'
import React, { CSSProperties, useEffect, useState } from 'react'
import { is } from '../../MediaQuery'
import SaveDatesButton from './components/SaveDatesButton'
import DatePickerDrawer from './DatePickerDrawer'
import DatePickerPopper from './DatePickerPopper'
import DatePickerWidget from './DatePickerWidget'
import { DatePickerDrawerFooter } from './styled'

interface IDateRangePickerProps {
  anchorEl: Element
  arrowRef?: Element
  open?: boolean
  styles?: CSSProperties
  placement?: PopperPlacementType
  initialDate?: Date
  onDateChange?: (date: Date) => void
  onClose?: () => void
  isAllowedDay?: (date: Date) => boolean
  minDate?: Date
  maxDate?: Date
}

export default ({
                  initialDate,
                  onDateChange,
                  onClose,
                  open,
                  minDate,
                  maxDate,
                  isAllowedDay,
                  ...rest
                }: IDateRangePickerProps) => {
  const [date, setDate] = useState(initialDate)
  const isMobile = is.mobile()

  useEffect(() => {
    if (open) {
      setDate(initialDate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const saveDateChanges = (jsDate?: Date) => {
    onDateChange && onDateChange(jsDate || date)
    onClose()
  }

  const widget = (
    <DatePickerWidget
      date={date}
      setDate={setDate}
      onDateChange={saveDateChanges}
      isAllowedDay={isAllowedDay}
      minDate={minDate}
      maxDate={maxDate}
    />
  )

  if (isMobile) {
    return (
      <DatePickerDrawer open={open} onClose={onClose} {...rest}>
        <>
          {widget}
          <DatePickerDrawerFooter>
            <SaveDatesButton isDisabled={!date} onClick={saveDateChanges}/>
          </DatePickerDrawerFooter>
        </>
      </DatePickerDrawer>
    )
  }

  return (
    <DatePickerPopper open={open} onClose={onClose} {...rest}>
      {widget}
    </DatePickerPopper>
  )
}
